import { TEACHER_ROUTE } from 'app/teacher/routing-constants/teacher-routing.constant';

export const HELP_REQUESTS_ROUTE = {
  name: 'helprequests',
  route(classId: string): string[] {
    return [...TEACHER_ROUTE.ACTIVE_CLASS.route(classId), this.name];
  }
};
